/* eslint-disable import/no-named-as-default-member */
import alertMessage from 'global/AlertMessage';
import chatApi from 'lib/api/chat';
import create from 'zustand';
import { IGroupMemberStore } from './types';

const groupMemberStore = create<IGroupMemberStore>((set, get) => ({
  data: {
    members: [],
    is_more: false,
  },
  isLoading: false,
  offset: 0,
  userUpdated: {
    userId: 0,
    isAdmin: true,
  },
  fetchGroupMember: async (groupId, offset) => {
    if (offset === 0) {
      set({ isLoading: true });
    }

    await chatApi.getMemberList(
      groupId,
      null, // keyword
      10, // limit
      offset,
    ).then((res) => {
      const { data } = res.data;
      if (offset === 0) {
        set({ data, isLoading: false, offset: 10 });
      } else {
        set({
          data: {
            members: [...get().data.members, ...data.members],
            is_more: data.is_more,
          },
          isLoading: false,
        });
      }
    }).catch(() => {
      set({ isLoading: false });
    });
  },
  setAdminStatus: async (groupId, userId, status) => {
    set({ isLoading: true });
    await chatApi.setAdminStatus(groupId, { user_id: userId, status })
      .then(async (res) => {
        set({
          offset: 0,
          isLoading: false,
          userUpdated: {
            userId,
            isAdmin: status,
          },
        });
        alertMessage({
          content: res.data?.message,
          alertType: 'snackbar',
          messageType: 'success',
          hasCloseIcon: false,
        });
        get().fetchGroupMember(groupId, 0);
      })
      .catch(() => {
        set({ isLoading: false });
      });
  },
  removeMember: async (groupId, userId, username) => {
    set({ isLoading: true });
    await chatApi.removeGroupMember(groupId, { user_id: userId })
      .then(() => {
        set({ isLoading: false });
        alertMessage({
          content: `${username} removed from the group`,
          alertType: 'snackbar',
          messageType: 'success',
          hasCloseIcon: true,
        });
        get().fetchGroupMember(groupId, 0);
      })
      .catch(() => {
        set({ isLoading: false });
      });
  },
}));

export default groupMemberStore;
